import request from '@/utils/request'; // 协议批改列查询

export function getList(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/findByConditions',
    method: 'post',
    data: data
  });
} // 分支机构查询

export function getChilComList(query) {
  return request({
    url: '/ecargopolicy/company/queryAll',
    method: 'get',
    params: query
  });
} // 获取保险公司集合

export function getCompanyList() {
  return request({
    url: '/ecargoaccount/user/findInsuranceCompany',
    method: 'get'
  });
} // 协议录入--查询

export function endorseInfo(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/endorseInfo',
    method: 'get',
    params: data
  });
} // 暂存-提交

export function submitEndorse(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/submitEndorse',
    method: 'post',
    data: data
  });
} // 列表删除

export function deleteEndorse(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/deleteEndorse',
    method: 'get',
    params: data
  });
} // 初始化

export function initEndorse(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/initEndorse',
    method: 'get',
    params: data
  });
} // 查询协议审核记录

export function queryAuditRecord(data) {
  return request({
    url: '/ecargopolicy/sysAuditrecord/queryAuditRecord',
    method: 'get',
    params: data
  });
} //协议批改审核通过/不通过

export function auditEndorse(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/auditEndorse',
    method: 'post',
    data: data
  });
} // 查询协议批改记录

export function findEndorseRecord(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/findEndorseRecord',
    method: 'get',
    params: data
  });
} // 批改协议删除操作

export function isDeleted(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/deleteRisk',
    method: 'post',
    data: data
  });
} // 协议批改生成批文接口

export function generateEndorseChar(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/generateEndorseChar',
    method: 'post',
    data: data
  });
} // 获取op协议号下已生效的批单数据接口

export function getEndorseValidData(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/getEndorseValidData',
    method: 'post',
    data: data
  });
} // 获取批文接口

export function getPiWenDataByEndorseApplyCode(data) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/getPiWenDataByEndorseApplyCode',
    method: 'get',
    params: data
  });
}